import bankAxios from './bankAxios'

export const banks = () => {
  return bankAxios.get(`/banks`, )
}

export const bank = (bankId) => {
  return bankAxios.get(`/${bankId}`)
}

export const postBank = (bank) => {
  return bankAxios.post(`/create`, bank)
}

export const putBank = (bank) => {
  return bankAxios.put(`/update`, bank)
}

export const enableBank = (bank) => {
  return bankAxios.put(`/enable`, bank)
}

export const disableBank = (bank) => {
  return bankAxios.put(`/disable`, bank)
}

export const getBankStats = () => {
  return bankAxios.get(`/dashboard/stats`)
}

